import LoadingCard from './LoadingCard.component';

export default LoadingCard;